/**
 * @license
 * Copyright 2021 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { WatchableValueInterface } from "#src/trackable_value.js";
import { animationFrameDebounce } from "#src/util/animation_frame_debounce.js";

export function bindTitle(title: WatchableValueInterface<string | undefined>) {
  const debouncedSetTitle = animationFrameDebounce(() => {
    const value = title.value?.trim();
    if (value) {
      document.title = `${value} - neuroglancer`;
    } else {
      document.title = "neuroglancer";
    }
  });
  const unregisterSignalHandler = title.changed.add(debouncedSetTitle);
  debouncedSetTitle();
  debouncedSetTitle.flush();
  return () => {
    unregisterSignalHandler();
    debouncedSetTitle.cancel();
  };
}
